import React from 'react';
import { ReactComponent as Spinner } from '../../assets/images/spinner.svg';

const Loader = () => {
  return (
    <div className="loader" role="status" aria-live="polite" aria-busy="true">
      <Spinner className="loader__spinner" aria-label="Loading" />
    </div>
  );
};

export default Loader;
